/*
 * @Author: Json Chen
 * @Date: 2021-07-19 12:18:22
 * @LastEditTime: 2021-12-29 11:12:33
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/PackingSlip/setting.tsx
 */

/*
 * @Author: Teemo Ding
 * @Date: 2021-06-29 17:14:47
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-08 17:58:36
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelInvoice/index.tsx
 */
import { Skeleton } from '@/src/components/Antd';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import { getWareHouseLocation } from '@/src/request/settings/logistics/wareHouseLocation';
import { useRequest } from 'ahooks';
import { Form, message } from 'antd';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';

import ErrorModal from '@/src/components/ErrorModal/ErrorModal';
import ErrorModalTitle from '@/src/components/ErrorModal/ErrorModalTitle';
import RouteBlock from '@/src/constrains/RouterBlock/RouterBlock';
import PackingSlipInformation from './PackingSlipInformation';
import PackingSlipSize from './PackingSlipSize';
// import InvoiceFormat from './InvoiceFormat';
import {
  getPackingSlip,
  setPackingSlip,
} from '@/src/request/settings/logistics/packingslip';
import { useHistory, useParams } from 'react-router';
import ModalHOC from 'src/constrains/ModalHOC';
import { getCountry, getState } from 'src/request/settings/storeDetails';
import OtherInformation from './OtherInformation';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { breadcrumbData } from './config';

const SalesChannelInvoice = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { modalOp } = props;
  const [form] = Form.useForm();
  const history = useHistory();
  const params: any = useParams();
  const [storeData, setStoreData] = useState({});
  const [information, setInformation] = useState([]);
  const [defaultAreaCode, setDefaultAreaCode] = useState('');
  const [defaultAreaText, setDefaultAreaText] = useState('');
  // const [storeInvoiceSetting, setStoreInvoiceSetting] = useState({} as any);
  const [storePackingSlipSetting, setStorePackingSlipSetting] = useState(
    {} as any,
  );
  const [countries, setCountries] = useState<string[]>([]);
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasModified, setHasModified] = useState(false);
  const { setShowModal, setModalTitle, setModalContent } = modalOp;
  const { warehouseUuid } = params;

  const { data: { locationName: warehouseName = '' } = {} } = useRequest(() =>
    getWareHouseLocation(warehouseUuid),
  );

  useEffect(() => {
    const lang = navigator.language; //获取浏览器默认语言。
    getCountry(lang).then((country) => {
      if (country) {
        setDefaultAreaCode(`+${country.areaCode}`);
        setDefaultAreaText(
          country.areaCode ? `${country.name} +(${country.areaCode})` : '',
        );
      }
    });

    getPackingSlip(warehouseUuid).then((data) => {
      setStoreData(data.store);
      setCountries(data.countries);
      if (data.store.country.code) {
        getState(data.store.country.code).then((state) => setStates(state));
      }
      setStorePackingSlipSetting(data.storePackingSlipSetting || {});
      setInformation(
        (data.storePackingSlipSetting.information || {}).items || [],
      );

      setLoading(false);
    });
  }, []);

  const goBackToList = () => {
    history.push({
      pathname: `/settings/logistics/warehouselocation/setting/${warehouseUuid}`,
    });
  };

  const topLeft = (
    <TopLeft
      goBack={goBackToList}
      breadcrumbData={breadcrumbData(warehouseName, warehouseUuid, { getI18n })}
    />
  );

  const addInformation = (item) => {
    const informationCopy = _.cloneDeep(information);
    informationCopy.push(item);
    setInformation(informationCopy);
    setShowModal(false);
    setHasModified(true);
  };

  const editInformation = (record) => {
    const informationCopy = _.cloneDeep(information);
    setInformation(
      informationCopy.map((item) => (item.uuid == record.uuid ? record : item)),
    );
    setShowModal(false);
    setHasModified(true);
  };
  const deleteInformation = (record) => {
    setShowModal(true);
    setModalTitle(
      <ErrorModalTitle>
        {getI18n('general.deletethisinformation')}
      </ErrorModalTitle>,
    );
    setModalContent(
      <ErrorModal
        setModal={setShowModal}
        onSubmit={() => handleDelete(record)}
        okText={getI18n('general.delete')}
        errorText={getI18n(
          'storeLogistics.packingSlip.deleteinformationErrorText',
        )}
      />,
    );
  };

  const handleDelete = (record) => {
    const informationCopy = _.cloneDeep(information);
    const arrDelete = informationCopy.filter(
      ({ uuid }) => uuid !== record.uuid,
    );
    setInformation(arrDelete);
    setHasModified(true);
  };

  const topRight = (
    <TopRight
      onDiscard={goBackToList}
      onSubmit={() => {
        form.submit();
      }}
      onSaveDisable={!hasModified}
    />
  );

  const onFinish = (values) => {
    values['information'] = {};
    values['information']['items'] = information;
    if (values.informationCustomized) {
      values = {
        ...values,
        ...{
          entityNameEnabled: values.entityNameEnabledCustomized,
          entityRegistrationNumberEnabled:
            values.entityRegistrationNumberEnabledCustomized,
          storeNameEnabled: values.storeNameEnabledCustomized,
          phoneEnabled: values.phoneEnabledCustomized,
          addressEnabled: values.addressEnabledCustomized,
          emailEnabled: values.emailEnabledCustomized,
          paymentEnabled: values.paymentEnabledCustomized,
          areaCodeInfo: values.areaCodeInfo,
          phone: values.phone,
          email: values.email,
          address: values.address,
          warehouse: { uuid: warehouseUuid },
        },
      };
    }

    setPackingSlip(values).then(() => {
      message.success(getI18n('general.savesuccess'));
      setHasModified(false);
    });
  };

  const Child = [
    {
      child: <PackingSlipSize />,
    },
    {
      child: (
        <PackingSlipInformation
          storeData={storeData}
          states={states}
          countries={countries}
          defaultAreaText={defaultAreaText}
        />
      ),
    },
    {
      child: (
        <OtherInformation
          information={information}
          setShowModal={setShowModal}
          setModalTitle={setModalTitle}
          setModalContent={setModalContent}
          addInformation={addInformation}
          editInformation={editInformation}
          deleteInformation={deleteInformation}
        />
      ),
    },
  ];
  const {
    informationCustomized = true,
    phoneEnabled = true,
    storeNameEnabled = true,
    emailEnabled = true,
    addressEnabled = true,
    paymentEnabled = true,
    entityNameEnabled = true,
    entityRegistrationNumberEnabled = true,
  } = storePackingSlipSetting;
  return (
    <Skeleton loading={loading} active>
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18n('general.discard')}
        active={hasModified}
        title={getI18n('general.commonHeader.discard_header')}
        content={getI18n('general.commonHeader.discard_content')}
      />
      <Form
        name='invoice'
        form={form}
        onFinish={onFinish}
        onValuesChange={() => {
          setHasModified(true);
        }}
        initialValues={{
          ...{
            slipSize: storePackingSlipSetting.slipSize || 'A4',
            slipTitle: storePackingSlipSetting.slipTitle || 'Packing Slip',
            logo: storePackingSlipSetting.logo,
            informationCustomized:
              storePackingSlipSetting.informationCustomized || false,
            phoneEnabledCustomized: informationCustomized ? phoneEnabled : true,
            phoneEnabled: !informationCustomized ? phoneEnabled : true,
            phone: storePackingSlipSetting.phone,
            areaCode: storePackingSlipSetting.areaCode || defaultAreaCode || '',
            areaCodeInfo:
              storePackingSlipSetting.areaCode || defaultAreaCode
                ? { uuid: defaultAreaCode }
                : '',
            storeNameEnabledCustomized: informationCustomized
              ? storeNameEnabled
              : true,
            storeNameEnabled: !informationCustomized ? storeNameEnabled : true,
            emailEnabledCustomized: informationCustomized ? emailEnabled : true,
            emailEnabled: !informationCustomized ? emailEnabled : true,
            email: storePackingSlipSetting.email,
            addressEnabledCustomized: informationCustomized
              ? addressEnabled
              : true,
            addressEnabled: !informationCustomized ? addressEnabled : true,
            address: storePackingSlipSetting.address,
            paymentEnabledCustomized: informationCustomized
              ? paymentEnabled
              : true,
            paymentEnabled: !informationCustomized ? paymentEnabled : true,
            entityNameEnabledCustomized: informationCustomized
              ? entityNameEnabled
              : true,
            entityNameEnabled: !informationCustomized
              ? entityNameEnabled
              : true,
            entityRegistrationNumberEnabledCustomized: informationCustomized
              ? entityRegistrationNumberEnabled
              : true,
            entityRegistrationNumberEnabled: !informationCustomized
              ? entityRegistrationNumberEnabled
              : true,
            subdivision: storePackingSlipSetting.subdivision,
            addressLine: storePackingSlipSetting.addressLine,
            postCode: storePackingSlipSetting.postCode,
          },
        }}>
        <Layout elements={Child} topLeft={topLeft} topRight={topRight}></Layout>
      </Form>
    </Skeleton>
  );
};

export default ModalHOC(SalesChannelInvoice);
